module.exports = __webpack_public_path__ + "img/VISITANOS-APP.dadb0380.png";